import * as React from "react";
import { DrawerPlmWithConfirmation } from "src/components/DrawerPlmWithConfirmation";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { observer } from "mobx-react-lite";
import { ZEntity } from "src/types/ZEntity";
import { cvtEntities, Mc2PointRow } from "./Mc2PointRow";
import { ZMc2Settings } from "../../../Mc2Types";

interface PropsMc2PointSelectModal {
  title: string;
  okText: string;
  open: boolean;
  close: () => void;
  settings: ZMc2Settings;
  multiple: boolean;
  success: (points: Mc2PointRow[]) => void;
  initialValue?: ZEntity;
}

export const Mc2PointSelectModal: React.FC<PropsMc2PointSelectModal> = observer(
  (props) => {
    const {
      title,
      okText,
      open,
      close,
      settings,
      multiple,
      success,
      initialValue,
    } = props;
    const { objPointId } = settings;
    const filtersPageStore = React.useMemo(
      () =>
        new EntityFiltersPageStore({
          objectId: objPointId!,
          selectionSettings: {
            keepSelected: true,
            selectionType: multiple ? "checkbox" : "radio",
          },
          onRowClick(row) {
            const store = filtersPageStore?.tableStore;
            if (store) {
              selectOnRowClick(row, store);
            }
          },
          actions: new Set(),
        }),
      [],
    );
    React.useEffect(() => {
      if (open) filtersPageStore.tableStore?.setSelected([]);
    }, [open]);
    const { tableStore } = filtersPageStore;
    React.useEffect(() => {
      if (initialValue && tableStore) {
        tableStore.setSelected([initialValue]);
      }
    }, [initialValue?.id, tableStore]);
    const disabled = !filtersPageStore.tableStore?.selected.length;
    let reason: string | undefined;
    if (disabled) {
      reason = multiple
        ? "Необходимо выбрать хотя бы одну строку"
        : "Необходимо выбрать одну строку";
    }
    return (
      <DrawerPlmWithConfirmation
        drawerProps={{
          title,
          open,
          onClose: close,
          styles: {
            body: {
              display: "flex",
            },
          },
        }}
        confirmationProps={{
          okText,
          okButtonProps: {
            onClick: () => {
              success(
                cvtEntities(
                  filtersPageStore.tableStore?.selected as ZEntity[],
                  settings,
                ),
              );
              close();
            },
            disabled,
            title: reason,
          },
          cancelButtonProps: {
            onClick: close,
          },
        }}
      >
        <EntityFiltersTable store={filtersPageStore} />
      </DrawerPlmWithConfirmation>
    );
  },
);
